export function stripNotificationReference(message: string) {
  if (!message) return "";
  return message.replace(/\s*\(Ref:\s*[^)]+\)\s*$/i, "").trim();
}